import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import DashboardNonMedical from './DashboardNonMedical';
import DashboardInfirmier from './pro/DashboardInfirmier';
import DashboardMedecin from './pro/DashboardMedecin';

/**
 * Dashboard Router - Charge le bon dashboard selon le profil utilisateur
 */
const Dashboard = () => {
  const { user } = useAuth();

  switch (user?.profile_type) {
    case 'non_medical':
      return <DashboardNonMedical />;
    case 'infirmier':
      return <DashboardInfirmier />;
    case 'medecin':
      return <DashboardMedecin />;
    default:
      console.warn('⚠️ profile_type non reconnu:', user?.profile_type);
      return <DashboardNonMedical />;
  }
};

export default Dashboard;
